import {
    Button,
    Typography
} from "@mui/material";
import {
    useEffect,
    useRef
}                   from "react";
import {
    ComplianceSchedule,
    ComplianceScheduleDetail,
    RegisterComplianceScheduleCommand,
    UpdateComplianceScheduleCommand
}                   from "../constants";
import {useZINContext} from "../context/ZinContextProvider";
import {
    submitNewComplianceObject,
    submitObject,
    submitUpdateComplianceObject
} from "../util";

const Form = () =>
{
    const {
        poolDetails, setModalVisible, formData, setRefreshResource,
        setAlertText, setAlertVisible
    } = useZINContext()

    //<editor-fold desc="Changeable Variables">
    const AddTitle = "Compliance Schedule toevoegen"
    const EditTile = "Compliance Schedule bewerken"

    const AddForm = "AddComplianceSchedule"
    const UpdateForm = "UpdateComplianceSchedule"

    const AggregateDetails = poolDetails
    const ExtraFormData = formData
    const SubmitButton = "Submit"

    const DetailRefresh = ComplianceScheduleDetail
    const MasterRefresh = ComplianceSchedule

    const AddCommand = RegisterComplianceScheduleCommand
    const UpdateCommand = UpdateComplianceScheduleCommand

    useEffect(() =>
    {
        if (FormRef.current !== undefined && ExtraFormData !== undefined)
        {
            FormRef.current.data = {...ExtraFormData}
        }
    }, []);
    //</editor-fold>

    //<editor-fold desc="Form - Does not need changing">
    const FormRef = useRef<any>()

    async function HandleSubmit(event: any, refresh : any)
    {
        //In case of a status that isnt 200, we most likely have received an error message.
        //So we display this as alert in the Modal
        if (event.status === 200)
        {
            //If everything went okay we can close it
            setModalVisible(false)
            setAlertVisible(false)
            setRefreshResource(refresh)
        }
        else
        {
            let response = await event.json()
            setAlertVisible(true)
            setAlertText(response.messages.reduceRight((acum: any, current: any) => acum.concat(current)))
        }

    }

    function onClickSubmit()
    {
        let Data: any = {}
        // @ts-ignore
        FormRef.current.getData().then((event: any) => Data = event)
        // @ts-ignore
        FormRef.current.submitForm().then(() =>
            {
                if (formData === undefined)
                {
                    submitNewComplianceObject(Data, AddCommand).then(async (event: any) =>
                    {
                        HandleSubmit(event,MasterRefresh)
                    })

                }
                else
                {
                    submitUpdateComplianceObject(Data, FormRef.current.data.id, UpdateCommand).then(async (event: any) =>
                    {
                        HandleSubmit(event,DetailRefresh)
                    })

                }
            }
        )

    }

    return (<>

        <Typography id="modal-modal-title" variant="h6" component="h2">
            {ExtraFormData === undefined
             ? AddTitle
             : EditTile}
        </Typography>
        {/*// @ts-ignore*/}

        {ExtraFormData === undefined
            // @ts-ignore
         ? <ig-form ref={FormRef} form-id={AddForm}/>
            // @ts-ignore
         : <ig-form ref={FormRef} form-id={UpdateForm}/>}
        <Button className={"od-button"} variant="contained" onClick={onClickSubmit}>{SubmitButton}</Button>
    </>)
    //</editor-fold>

}
export default Form